import { FILTER_FORM_LABEL_MAP } from '../../util/constants.js'
import {
  mapArrayToObjectByKey,
  mapArrayStringsToInt,
  capitalizeFirstLetter,
} from '../../util/helper.js'
import { mapConnection, findTag } from '../util.js'

// @TODO implement
export const hasPublicConnections = (state) => {
  return true
  return !!state.settings?.publicContactsCount
}

export const isManagerContext = () => (route) => {
  return route.includes('manager')
}

// CONNECTIONS
export const getConnections = (state) => {
  return state.connections
}

export const getOrganisationConnections = (state) => {
  // Sort disabled connections last!
  return [...state.organisationConnections].sort((a, b) => {
    if (a.disabled === b.disabled) {
      return 0
    }
    if (a.disabled) {
      return 1
    }
    return -1
  })
}

export const getConnectionsMappedById = (_state, getters) => {
  return mapArrayToObjectByKey(getters.getConnections)
}

export const getConnectionsMappedByOrganisationId = (_state, getters) => {
  return mapArrayToObjectByKey(getters.getConnections, 'organisationId')
}

export const getConnection = (_state, getters) => (connectionId) => {
  return mapConnection(getters.getConnectionsMappedById[connectionId])
}

// ORGANISATIONS
export const getOrganisations = (state) => {
  return state.organisations
}

export const getOrganisationsMappedById = (state) => {
  return mapArrayToObjectByKey(state.getters.getOrganisations)
}

export const getOrganisation = (state) => (organisationId) => {
  return state.getters.getOrganisations.find(
    (organisation) => organisation.id === organisationId,
  )
}

// REPORTS
export const getReports = (state) => {
  return state.reports
}

export const getReportsMappedById = (state) => {
  return mapArrayToObjectByKey(state.getters.getReports)
}

export const getReport = (state) => (reportId) => {
  return state.getters.getReports.find((report) => report.id === reportId)
}

export const getReportsStats = (state) => {
  return state.reportsStats
}

export const getReportSelectedConnections = (state) => {
  return state.reportSelectedConnections
}

// Could move this to careerwise/shared ?
export const getPostSelectedConnections = (state) => {
  return state.postSelectedConnections
}

// FILTERS
export const getFilterForm = (state) => {
  return state.filterForm
}

/**
 * Example data structure (key is id of selected tag or form value name):
  {
    12: {
      name: 'preferences',
      data: { text: 'text', description: 'desc', value: 12 },
    },
    14: {
      name: 'schoolSupport',
      data: { text: 'text', description: 'desc', value: 14 },
    },
    policeChecked: {
      name: 'policeChecked',
      data: { text: 'text', description: 'desc', value: true },
    },
  }
 */
export const getSelectedFilters = (
  _state,
  getters,
  _rootState,
  rootGetters,
) => {
  const tagsAll = rootGetters['shared/getTagsAll']
  const filterForm = getters.getFilterForm
  // If an item is present in this map, it is selected!
  return Object.keys(filterForm).reduce((acc, key) => {
    const value = filterForm[key]
    if (Array.isArray(value)) {
      // Form tags
      value.reduce((acc, tagId) => {
        acc[tagId] = {
          name: key,
          data: findTag(tagsAll, tagId),
        }
        return acc
      }, acc)
    } else if (value) {
      if (key.includes('date')) {
        let dateText = ''

        if (key === 'dateYear') {
          dateText = 'Selected Year'
        } else {
          // "Date From" or "Date To"
          dateText = capitalizeFirstLetter(
            key.replace(/([A-Z])/g, ' $1').trim(),
          )
        }

        acc[key] = {
          name: key,
          data: {
            text: `${dateText}: ${value}`,
            description: `${FILTER_FORM_LABEL_MAP[key]}: ${value}`,
            value,
          },
        }
      } else if (key === 'keywords') {
        // Only show user this selected option if it's not whitespace!
        if (value.trim()) {
          acc[key] = {
            name: key,
            data: {
              text: value,
              description: value,
              value,
            },
          }
        }
      } else {
        // Form booleans
        acc[key] = {
          name: key,
          data: {
            text: FILTER_FORM_LABEL_MAP[key],
            description: FILTER_FORM_LABEL_MAP[key],
            value,
          },
        }
      }
    }
    return acc
  }, {})
}

export const getSelectedFiltersWithBlacklist =
  (_state, getters) =>
  (blacklist = ['dateFrom', 'dateTo', 'dateYear', 'keywords']) => {
    const selectedFilters = getters.getSelectedFilters

    return Object.entries(selectedFilters)
      .filter(([key, value]) => !blacklist.includes(value.name))
      .reduce((obj, [key, value]) => {
        obj[key] = value
        return obj
      }, {})
  }

export const getSelectedFiltersCount = (_state, getters) => {
  return Object.keys(getters.getSelectedFilters)?.length
}

export const getReportsYearsOptions = (state) => {
  return state.reportsYears
}

export const getFilterTitle = () => (opt) => {
  const title = opt.data.description || FILTER_FORM_LABEL_MAP[opt.name]
  if (title) {
    return capitalizeFirstLetter(title)
  }

  return ''
}

export const getFilterFormKeywords = (_state, getters) => {
  return getters.getFilterForm?.keywords || null
}

export const getFilterFormDateRange = (_state, getters) => {
  const selectedFilters = getters.getSelectedFilters
  const whitelist = ['dateFrom', 'dateTo']

  return Object.entries(selectedFilters)
    .filter(([key, value]) => whitelist.includes(value.name))
    .reduce((obj, [key, value]) => {
      obj[key] = value
      return obj
    }, {})
}

export const getFilterFormSelectedYear = (_state, getters) => {
  return getters.getFilterForm?.dateYear || null
}

export const getFilterFormPayload = (_state, getters) => {
  const data = getters.getFilterForm
  const payload = {}

  let tags = []
  for (const value of Object.values(data)) {
    // All arrays are tags
    if (Array.isArray(value)) {
      tags = tags.concat(value)
    }
  }

  payload.tags = mapArrayStringsToInt(tags)
  // policeChecked: false - default to null to 'ignore' this filter
  payload.police_checked = data.policeChecked || null
  payload.keywords = data.keywords || null
  payload.dateFrom = data.dateFrom || null
  payload.dateTo = data.dateTo || null
  payload.selectedYear = data.dateYear || null

  return payload
}
